import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { FlexContainer } from 'base-components';
import SelectController from './SelectController';
import withTranslation from 'app-hocs/withTranslation';
import ComponentLoading from '../Loading/ComponentLoading';
import { get } from 'lodash';
import { connect } from 'formik';

const InputContainer = styled(FlexContainer)`
  width: ${({ width }) => width || '100%'};
  ${({ layout = 'column' }) => {
    if (layout === 'row') return css`margin: 0px 10px;`;
    return css`margin: 10px 0px;`;
  }}
`;

const Label = styled.label`
  color: #333333;
  margin-right: 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: normal;

  ${props => props.error && `
    color: #d60101;
  `}
`;

const Help = withTranslation(({ error }) => {
    const HelpContent = styled.span`
      color: red;
      font-size: 11px;
      font-style: italic;
      padding: 5px 0px;
      ${props => props.error && `
        color: #d60101;
      `}

      ${props => props.success && `
        border: solid 1px #4cb358;
      `}
    `;
    return (
        <HelpContent error={error}>
            {error}
        </HelpContent>
    );
}, ['error']);

const FormSelect = ({ style, layout, direction, name, type, error, success, label, loading, placeholder, width, ...props }) => {
  if (loading) return <ComponentLoading />;
  return (
      <InputContainer width={width} direction='column' style={style} layout={layout}>
          <FlexContainer direction={direction}>
              { label && <Label type={type} success={success}>{label}</Label>}
              <SelectController name={name} {...props} error={error} label={placeholder} />
          </FlexContainer>
          {error && <Help error={error}>{error} </Help>}
      </InputContainer>
    );
};

FormSelect.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    layout: PropTypes.string,
    error: PropTypes.bool,
    direction: PropTypes.string,
    success: PropTypes.bool,
    name: PropTypes.string,
    type: PropTypes.string,
    onChangeSelectAll: PropTypes.func,
    onchange: PropTypes.func,
    style: PropTypes.object,
    value: PropTypes.any,
    loading: PropTypes.bool,
    placeholder: PropTypes.string,
    width: PropTypes.string
};

FormSelect.defaultProps = {
    direction: 'column',
    disabled: false
};

const FormikSelect = connect(({ field: { onChange, onBlur, name, ...field }, form: { errors, dirty, touched, ...form }, getDefaultSelected, allSelected, fromUserSelect, onChangeStoreKind, formik: { setFieldValue, ...formik }, ...props }) => {
    const defaultSelected = allSelected ? get(props, 'options', []) : getDefaultSelected(field);
    return (
        <FormSelect
            fromUserSelect={fromUserSelect}
            name={name}
            {...field}
            {...props}
            value={defaultSelected}
            allSelected={allSelected}
            defaultValue={defaultSelected}
            error={(touched[name]) && errors[name]}
            onChange={({ value }) => {
              onChangeStoreKind(value);
              setFieldValue(name, value);
            }}
        />
    );
});

FormikSelect.defaultProps = {
    getDefaultSelected: (field) => (get(field, 'value')),
    onChangeStoreKind: () => {}

};

export { FormSelect, FormikSelect };
